import { useRef, useCallback } from 'react';

function useHoverHandlersDelay(_ref) {
  var onMouseOver = _ref.onMouseOver,
      onMouseLeave = _ref.onMouseLeave,
      _ref$hideDelay = _ref.hideDelay,
      hideDelay = _ref$hideDelay === void 0 ? 300 : _ref$hideDelay,
      _ref$showDelay = _ref.showDelay,
      showDelay = _ref$showDelay === void 0 ? 300 : _ref$showDelay;
  var hideTimer = useRef();
  var showTimer = useRef();
  var delayedHide = useCallback(function () {
    clearTimeout(showTimer.current);
    hideTimer.current = setTimeout(onMouseLeave, hideDelay);
  }, []);
  var delayedShow = useCallback(function () {
    clearTimeout(hideTimer.current);
    showTimer.current = setTimeout(onMouseOver, showDelay);
  }, []);
  return {
    onMouseOver: delayedShow,
    onMouseLeave: delayedHide
  };
}

export default useHoverHandlersDelay;
//# sourceMappingURL=useHoverHandlersDelay.js.map
